<template>
  <v-container fluid class="pa-4 pa-sm-6">
    <!-- ВЕРХНЯЯ ПАНЕЛЬ: Переключатель недель -->
     <PageTitle title="Расписание" />

    <v-row class="align-center mb-4" no-gutters>
      <v-col cols="12" sm="7" class="d-flex align-center mb-3 mb-sm-0">
        <v-btn icon="mdi-chevron-left" variant="outlined" density="comfortable" @click="navigateWeek(-1)"></v-btn>

        <v-btn variant="text" class="mx-1 font-weight-bold text-body-1" @click="setTodayWeek">
          {{ formattedWeekRange }}
        </v-btn>

        <v-btn icon="mdi-chevron-right" variant="outlined" density="comfortable" @click="navigateWeek(1)"></v-btn>

        <v-btn v-if="!isCurrentWeekSelected" size="small" variant="tonal" color="secondary" class="ml-2" @click="setTodayWeek">
          Текущая неделя
        </v-btn>
      </v-col>

      <v-col cols="12" sm="5" class="text-sm-right" v-if="isAdminOrTeacher">
        <v-btn  color="deep-orange-darken-1" size="large" class="font-weight-bold px-6" prepend-icon="mdi-calendar-plus" @click="openCreateDialog">
          Запланировать
        </v-btn>
      </v-col>
    </v-row>

    <!-- ИНДИКАТОР ЗАГРУЗКИ СЕТКИ -->
    <v-progress-linear v-if="isScheduleLoading" indeterminate color="primary" class="mb-4 rounded"></v-progress-linear>

    <!-- ОСНОВНАЯ СЕТКА ДНЕЙ НЕДЕЛИ -->
    <v-row v-if="!isScheduleLoading">
      <v-col v-for="day in weekDays" :key="day.dateString" cols="12" md="6" lg="4" xl="3" class="d-flex">
        <v-card :class="['rounded-lg flex-grow-1 border-top-thick d-flex flex-column', isToday(day.dateString) ? 'border-primary elevation-3' : 'elevation-1 border']" variant="flat">

          <!-- Шапка дня недели -->
         <template v-slot:title>
           <div class="d-flex align-center w-100">
             <!-- Название слева -->
             <span class="font-weight-black"  :class="isToday(day.dateString) ? 'text-deep-orange-darken-1' : 'text-grey-darken-1'">
               {{ day.dayName }}
             </span>

             <!-- Расталкиватель посередине -->
             <v-spacer></v-spacer>

             <!-- Чип справа -->
             <v-chip
               :color="isToday(day.dateString) ? 'deep-orange-darken-1' : 'grey-darken-1'"
               size="small"
               variant="flat"
               class="font-weight-bold"
             >
               {{ day.displayDate }}
             </v-chip>
           </div>
         </template>

          <!-- Лента карточек событий дня -->
          <v-card-text class="pa-2 overflow-y-auto flex-grow-1" style="max-height: 550px; min-height: 120px;">
            <div v-if="getDayEvents(day.dateString).length === 0" class="text-center text-grey py-10 text-caption font-italic">
              Нет запланированных событий
            </div>

            <v-card
              v-for="event in getDayEvents(day.dateString)"
              :key="event.id"
              class="mb-2 pa-3 rounded-lg border-s-lg elevation-0 bg-grey-lighten-5 border position-relative"
              :style="{ borderColor: getEventColor(event.eventType) + ' !important' }"
            >



              <!-- Метки типа и времени -->
              <div class="d-flex justify-space-between align-center mb-2 pr-6">

                   <h3>{{ getEventTypeText(event.eventType) }}</h3>

                <span class="text-caption font-weight-bold text-grey-darken-3">
                  <v-icon size="x-small" class="mr-1">mdi-clock-outline</v-icon>
                  {{ formatTime(event.startTime) }}{{ event.endTime ? ' - ' + formatTime(event.endTime) : '' }}
                </span>
              </div>

              <div class="text-body-2 font-weight-bold text-grey-darken-4 mb-1">{{ event.title }}</div>
              <div v-if="event.description" class="text-caption text-grey-darken-2 mb-2 whitespace-pre-line">{{ event.description }}</div>
<!-- Список файлов -->

      <div v-if="event.attachedFiles && event.attachedFiles.length" class="files-section mb-4">
        <h5 class="files-title">Прикрепленные файлы:</h5>

        <div class="files-list">
          <div
            v-for="file in event.attachedFiles"
            :key="file.id"
            class="file-item"
          >
            <!-- Иконка и имя файла -->
            <div class="file-info" @click="downloadFile(file.id, file.fileName)">
              <span class="file-icon">{{ getFileIcon(file.fileName) }}</span>
              <span
                class="file-name"
                :class="{ 'is-downloading': loadingId === file.id }"
              >
                {{ loadingId === file.id ? 'Скачивание...' : file.fileName }}
              </span>
            </div>

            <!-- Кнопка удаления -->
            <button
              @click.stop="deleteFile(event.id, file.id)"
              class="file-delete-btn"
              title="Удалить файл"
              :disabled="deletingFileId === file.id"
            >
              <span v-if="deletingFileId === file.id" class="spinner">⏳</span>
              <span v-else>🗑️</span>
            </button>
          </div>
        </div>
      </div>


              <!-- Команды -->
              <div class="mb-1" v-if="event.targetGroups && event.targetGroups.length > 0">
                <h5>Команды:</h5>
                <v-chip v-for="team in event.targetGroups" :key="team.id" size="x-small" variant="tonal" color="deep-orange-darken-3" class="mr-1 mb-1">
                  {{ team.personGroupName }}
                </v-chip>
              </div>

              <!-- Вебинарная ссылка -->
              <div v-if="event.eventType === 'WEBINAR' && event.webinarLink" class="bg-blue-lighten-5 pa-2 rounded-lg mt-2 border border-blue-lighten-4">
                <div class="d-flex align-center justify-space-between mb-1">
                  <span class="text-blue-darken-4 font-weight-bold text-caption">Вебинар:</span>
                  <v-btn :href="event.webinarLink" target="_blank" size="x-small" color="blue-darken-1" variant="flat" prepend-icon="mdi-video">Войти</v-btn>
                </div>
                <div v-if="event.accessCode" class="text-caption text-grey-darken-3">Код: <code>{{ event.accessCode }}</code></div>
              </div>
                 <!-- [ДОБАВИТЬ ЭТОТ БЛОК] Блок прикрепленных методических материалов (PDF, DOCX) -->
                              <div v-if="event.attachedMaterials && event.attachedMaterials.length > 0" class="border-t pt-2 mt-2">
                                <div class="text-caption font-weight-bold text-grey-darken-3 mb-1">
                                  <v-icon size="x-small" class="mr-1">mdi-paperclip</v-icon>
                                  Методические материалы:
                                </div>

                                <!-- Рендерим только документы (пропускаем видео, так как для них есть отдельная кнопка медиатеки) -->
                                <div
                                  v-for="file in event.attachedMaterials"
                                  :key="file.id"
                                  class="d-flex align-center text-caption text-primary cursor-pointer mb-1 hover-underline"
                                  @click="downloadSecureFile(file.id, file.fileName)"
                                  title="Нажмите, чтобы скачать документ"
                                >
                                  <!-- Динамическая иконка в зависимости от расширения файла -->
                                  <v-icon size="x-small" :color="getFileIconColor(file.fileName)" class="mr-1">
                                    {{ getFileIcon(file.fileName) }}
                                  </v-icon>
                                  <span class="text-decoration-underline text-truncate-1 text-grey-darken-4">
                                    {{ file.fileName }}
                                  </span>
                                </div>
                              </div>


                           <!-- Блок прикрепленных видеоуроков (HLS-видео) -->
                                        <div v-if="hasVideoMaterials(event.attachedMaterials)" class="border-t pt-2 mt-2">
                                          <div class="text-caption font-weight-bold text-grey-darken-3 mb-1">
                                            <v-icon size="x-small" color="red" class="mr-1">mdi-play-circle</v-icon>
                                            Видеоматериалы к занятию:
                                          </div>

                                          <!-- Кнопка запуска вашей медиатеки с плеером -->
                                          <v-btn
                                            variant="flat"
                                            color="indigo-darken-4"
                                            size="x-small"
                                            block
                                            prepend-icon="mdi-movie-play-outline"
                                            class="font-weight-bold text-white rounded-md mt-1"
                                            @click="openMediaForEvent(event)"
                                          >
                                            Смотреть видеоуроки
                                          </v-btn>
                                        </div>
                                        <v-card-actions>
                                        <!-- Кнопка удаления для админа -->

                                                      <v-btn


                                                        icon="mdi-pencil-outline"
                                                        size="x-small"
                                                        variant="outlined"
                                                        color="deep-orange-darken-1"
                                                        @click="editEvent(event)">

                                                      </v-btn>
                                                      <v-btn


                                                        icon="mdi-file"
                                                        size="x-small"
                                                        variant="outlined"
                                                        color="deep-orange-darken-1"
                                                        @click="addFiles(event)">

                                                      </v-btn>
                                                      <v-btn


                                                        icon="mdi-video-outline"
                                                        size="x-small"
                                                        variant="outlined"
                                                        color="deep-orange-darken-1"
                                                        @click="addVideoFiles(event)">

                                                      </v-btn>
                                                      <v-btn

                                                        icon="mdi-close"
                                                        size="x-small"
                                                        variant="outlined"
                                                        color="error"
                                                        @click="confirmDeleteEvent(event.id)">

                                                      </v-btn>
                                        </v-card-actions>
            </v-card>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

     <v-dialog v-model="fileDialog"  max-width="550px" persistent>
        <v-card v-if="selectedEvent"  class="rounded-lg">
          <v-card-title class="text-h6 font-weight-bold  bg-deep-orange-darken-1">
             Добавление файлов для {{selectedEvent.title}}
          </v-card-title>
          <v-card-text class="px-4">
            <v-form ref="fileForm" v-model="isFormValid">
                <!-- Интерактивный загрузчик файлов методичек/PDF -->
                <div class="mb-2">
                  <div class="text-caption font-weight-bold text-grey-darken-3 mb-1">
                    <v-icon size="small" class="mr-1">mdi-paperclip</v-icon>
                    Прикрепить методические материалы (PDF, DOCX)
                  </div>
                  <FileUploader :eventId = "selectedEvent.id"   @files-updated="handleFilesUpdated" />
                </div>
            </v-form>
          </v-card-text>

          <v-card-actions class="px-4 pb-4">
            <v-spacer></v-spacer>
            <v-btn color="grey-darken-1" variant="text" @click="closeFilesDialog">Закрыть</v-btn>
          </v-card-actions>
        </v-card>
     </v-dialog>


    <!-- МОДАЛЬНОЕ ОКНО СОЗДАНИЯ (Интерфейс Администратора/Преподавателя) -->
    <CreateEventDialog
      v-model="createDialog"
      :default-date="currentMonday.toISOString().split('T')[0]"
      @saved="fetchWeeklySchedule"
    />

     <v-dialog v-model="mediaDialog" max-width="850px" width="95%" persistent>
       <v-card v-if="selectedEvent" class="rounded-lg overflow-hidden d-flex flex-column" style="max-height: 85vh;">
         <v-card-title class="bg-deep-orange-darken-1 px-4 px-md-6 py-3 text-white d-flex align-start align-sm-center justify-space-between w-100">
           <div class="d-flex align-start align-sm-center flex-column flex-sm-row text-truncate mr-2">
             <div class="d-flex align-center mb-1 mb-sm-0">
               <v-icon start class="mr-2">mdi-folder-image</v-icon>
               <span class="text-subtitle-1 font-weight-bold text-grey-lighten-3 mr-1">Медиатека:</span>
             </div>
             <span class="text-subtitle-1 text-sm-h6 font-weight-black text-truncate text-white pl-0 pl-sm-1">
                 {{ selectedEvent.title }}
             </span>
           </div>
           <v-btn icon="mdi-close" variant="text" color="white" density="compact" class="ml-auto ma-2" @click="closeMediaModal"></v-btn>
         </v-card-title>
         <!-- Основной контент галереи -->
         <v-card-text class="pa-4 pb-6 pa-md-6 bg-grey-lighten-4 overflow-y-auto">
           <v-row no-gutters>
           <!-- ЛЕВАЯ КОЛОНКА: Галерея текущих файлов ученика из БД -->
             <v-col cols="12" md="7" class="pa-2 mb-6">
               <div class="text-subtitle-2 font-weight-bold text-grey-darken-3 mb-2">Загруженные видео материалы</div>
               <div class="media-gallery-grid" v-if="selectedEvent.videoFiles && selectedEvent.videoFiles.length > 0">
                 <v-card
                   v-for="(file, idx) in selectedEvent.videoFiles"
                   :key="idx"
                   variant="outlined"
                   class="bg-white rounded-md overflow-hidden position-relative media-preview-card ma-2"
                 >
                  <div class="video-preview-zone d-flex align-center justify-center bg-grey-darken-4 rounded-md overflow-hidden" style="height: 140px;">
                    <video
                      :poster="'https://esse2.eurekacenter.ru/' + formatServerPath(file.posterName)"
                      controls
                      playsinline
                      class="w-100 h-100 object-cover"
                      @vue:mounted="(vnode) => initHlsPlayer(vnode.el, 'https://esse2.eurekacenter.ru/' + formatServerPath(file.sourceHlsIndex))"
                    >
                      <source :src="'https://esse2.eurekacenter.ru' + formatServerPath(file.fileUrl)" type="application/x-mpegURL">
                    </video>
                  </div>
                  <!-- Интерактивный переключатель 4 разрешений (Выводится строго под плеером) -->
                  <div v-if=" availableLevels.length > 0" class="mt-2 text-right px-1">
                    <v-menu location="bottom end">
                      <template v-slot:activator="{ props }">
                        <v-btn
                          v-bind="props"
                           size="x-small"
                            variant="outlined"
                            color="grey-darken-3"
                            prepend-icon="mdi-cog-outline"
                            class="rounded-md font-weight-bold mr-2"
                            style="height: 24px; border: 1px solid rgba(0,0,0,0.15) !important;"
                        >
                         Качество: {{ currentLevelIndex === -1 ? 'Авто' : availableLevels.find(l => l.index === currentLevelIndex)?.name }}
                        </v-btn>
                      </template>
                      <!-- Выпадающий список разрешений из .m3u8 -->
                      <v-list density="compact" class="rounded-md border pa-1 bg-white">
                        <v-list-item
                          v-for="level in availableLevels"
                          :key="level.index"
                          @click="changeVideoQuality(level.index)"
                          :class="{ 'bg-indigo-lighten-5 font-weight-bold text-indigo-darken-4': currentLevelIndex === level.index }"
                          class="rounded-sm"
                        >
                          <v-list-item-title class="text-caption" style="font-size: 0.75rem !important;">
                            {{ level.name }}
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                  <div v-if="isAdminOrTeacher"  class="mt-2 text-right px-1">
                    <span class="text-caption text-grey-darken-2 font-weight-medium text-truncate ">
                      {{file.status}}
                    </span>
                    <!-- КНОПКА УДАЛЕНИЯ МЕДИАФАЙЛА -->
                    <v-btn
                        icon="mdi-delete-outline"
                        size="x-small"
                        variant="text"
                        color="error"
                        title="Удалить видео"
                        @click="deleteMediaFile(file.id)"
                    ></v-btn>
                  </div>
                  </v-card>
                  </div>
                  <!-- Заглушка, если файлов пока нет -->
                  <div v-else class="d-flex flex-column align-center justify-center bg-white rounded-md border py-12 px-4 text-center h-100 min-h-220">
                        <v-icon size="large" color="grey-lighten-1" class="mb-2">mdi-image-off-outline</v-icon>
                        <span class="text-caption text-grey font-italic">Файлы видеоотчетов отсутствуют</span>
                  </div>
                </v-col>

                <!-- ПРАВАЯ КОЛОНКА: Зона прикрепления новых файлов -->
                <v-col v-if="isAdminOrTeacher" cols="12" md="5" class="pa-2 border-left-light-modal">
                  <div class="text-subtitle-2 font-weight-bold text-grey-darken-3 mb-3">Прикрепить новые материалы</div>
                  <div class="d-flex flex-column gap-2">
                    <!-- Скрытые нативные файловые инпуты диска -->
                     <input type="file" ref="videoInputRef" accept="video/*" class="d-none" @change="uploadVideoFile" />

                     <!-- Кнопка 2: Загрузить видео -->
                     <v-btn
                      prepend-icon="mdi-video-outline"
                      variant="outlined"
                      color="deep-orange-darken-1"
                      block
                      class="rounded-md font-weight-bold py-5 text-body-2 mt-2"
                      :disabled="downloadAnimation"
                      @click="$refs.videoInputRef.click()"
                     >
                       Прикрепить видеоролик
                     </v-btn>
                  </div>
                  <!--  Индикатор процентов прогресса загрузки -->
                  <div class="mt-4 pa-3 bg-white rounded-md border text-center" v-if="downloadAnimation">
                    <div class="text-caption font-weight-bold text-grey-darken-3 mb-1">
                      Отправка файла на сервер...
                    </div>
                    <v-progress-linear
                      v-model="uploadPercentage"
                      color="indigo"
                      height="8"
                      rounded
                      striped
                    ></v-progress-linear>
                    <span class="text-caption font-weight-black text-indigo d-block mt-1">
                      {{ uploadPercentage }}%
                    </span>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
  </v-container>
</template>
<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import PageTitle from "@/elements/PageTitle.vue";
import { customAxios } from "@/service/customAxios";
import CreateEventDialog from '@/schedule/CreateEventDialog.vue'
import FileUploader from '@/schedule/FileUploader.vue'
import { usePopupStore } from "@/store/popup";
const { showToastPopup } = usePopupStore();
const { showError } = usePopupStore();
//import MediaViewerDialog from '@/schedule/MediaViewerDialog.vue'
// Ролевая модель (в реальном приложении получается из Pinia/Vuex/Сессии)
const userRole = ref('ADMIN') // Возможные значения: ADMIN, TEACHER, STUDENT
const studentTeamId = ref(5)     // ID команды студента
const isFormValid = ref(false);
// Состояния загрузок и модальных окон
const isScheduleLoading = ref(false)

const isTeamsLoading = ref(false)
const createDialog = ref(false)
// Переменные состояния для медиа-диалога
const mediaDialog = ref(false)
const activeModule = ref(null)
const videoFiles = ref([])
const editingEvent = ref();
const videoInputRef = ref(null);
// --- Переменные для интеграции с MediaViewerDialog ---
let currentHlsInstance = null;
// файлы
const fileDialog = ref(false);
const attachedFileIds = ref([]);
//const isSaving = ref(false)
const loadingId = ref(null)
const deletingFileId = ref(null)


// НЕДОСТАЮЩИЕ РЕАКТИВНЫЕ ПЕРЕМЕННЫЕ (Добавьте их):
const downloadAnimation = ref(false)
const uploadPercentage = ref(0)
const availableLevels = ref([])
const currentLevelIndex = ref(-1)
const selectedEvent = ref(null);


// Массивы данных из БД
const events = ref([])
const availableTeams = ref([])

// Смещение недель относительно текущей (0 — текущая, -1 — прошлая, 1 — следующая)
const weekOffset = ref(0)

// 🗑️ Метод удаления файла
const deleteFile = async (eventId, fileId) => {
  // Подтверждение перед удалением (по желанию)
  if (!confirm('Вы уверены, что хотите удалить этот файл?')) return

  deletingFileId.value = fileId
  try {
    const r = await customAxios.delete(`/v1/files/${fileId}`);
    if(r.status === 202){
    await fetchWeeklySchedule();
    showToastPopup ? showToastPopup("Файл успешно удален!") : alert("Файл успешно удален!");

    }


  } catch (e) {
    console.error('Ошибка при удалении файла:', e)
    alert('Не удалось удалить файл. Попробуйте позже.')
  } finally {
    deletingFileId.value = null
  }
}



// Права текущего пользователя на добавление и удаление
const isAdminOrTeacher = computed(() => {
  return userRole.value === 'ADMIN' || userRole.value === 'TEACHER'
})

// Календарная логика: Вычисление даты Понедельника выбранной недели
const currentMonday = computed(() => {
  const today = new Date()
  const dayOfWeek = today.getDay() // 0 (вс) - 6 (сб)
  const dayOffset = dayOfWeek === 0 ? -6 : 1 - dayOfWeek // Сдвиг к понедельнику

  const monday = new Date(today)
  monday.setDate(today.getDate() + dayOffset + (weekOffset.value * 7))
  monday.setHours(0, 0, 0, 0)
  return monday
})

// Проверка: Выбрана ли текущая календарная неделя
const isCurrentWeekSelected = computed(() => {
  return weekOffset.value === 0
})

// Текст диапазона дат в селекторе недель (например: "24 авг — 30 авг 2026")
const formattedWeekRange = computed(() => {
  const start = new Date(currentMonday.value)
  const end = new Date(currentMonday.value)
  end.setDate(start.getDate() + 6)

  const options = { month: 'short', day: 'numeric' }
  const startText = start.toLocaleDateString('ru-RU', options)
  const endText = end.toLocaleDateString('ru-RU', options)
  const year = end.getFullYear()

  return `${startText} — ${endText} ${year}`
})





// Функции управления селектором недель
const navigateWeek = (direction) => {
  weekOffset.value += direction
}

const setTodayWeek = () => {
  weekOffset.value = 0
}

const isToday = (dateString) => {
  const localToday = new Date()

  // Если код отстает на день, принудительно двигаем дату вперед на 1 день для компенсации UTC
  localToday.setDate(localToday.getDate() - 1)

  const todayStr = localToday.toISOString().split('T')[0]
  return dateString === todayStr
}
// Объект формы для создания нового события
const defaultEvent = {
  title: '',
  description: '',
  eventType: 'LESSON',
  date: '',
  startTime: '',
  endTime: '',
  webinarLink: '',
  accessCode: '',
  targetTeamIds: []
}
const newEvent = ref({ ...defaultEvent })

// 📥 Загрузка массива событий на неделю с бэкенда
const fetchWeeklySchedule = async () => {
  isScheduleLoading.value = true
  try {
    const startDate = currentMonday.value.toISOString().split('T')[0]
    const end = new Date(currentMonday.value)
    end.setDate(end.getDate() + 6)
    const endDate = end.toISOString().split('T')[0]

    const params = {
      startDate,
      endDate,
      userRole: userRole.value
    }

    if (userRole.value === 'STUDENT') {
      params.teamId = studentTeamId.value
    }

    const response = await customAxios.get('/v1/schedule', { params })
    events.value = response.data

      // 🔄 Обновление выбранного события актуальными данными
        if (selectedEvent.value && Array.isArray(response.data)) {
          const updatedEvent = response.data.find(event => event.id === selectedEvent.value.id)
          if (updatedEvent) {
            selectedEvent.value = updatedEvent
          }
        }

  } catch (e) {
    console.error('Ошибка при загрузке расписания:', e)
  } finally {
    isScheduleLoading.value = false
  }
}

// 📥 Загрузка списка доступных команд (для формы админа)
const fetchAvailableTeams = async () => {
  if (!isAdminOrTeacher.value) return
  isTeamsLoading.value = true
  try {
    const response = await customAxios.get('/user_group') // Предполагаемый ваш эндпоинт команд
    availableTeams.value = response.data
  } catch (e) {
    console.error('Ошибка загрузки команд:', e)
  } finally {
    isTeamsLoading.value = false
  }
}
 function editEvent(event) {
    editingEvent.value = event;

    createDialog.value = true;


}
// 1. ИСПРАВЛЕННАЯ ФИЛЬТРАЦИЯ СОБЫТИЙ
const getDayEvents = (dateString) => {
  return events.value.filter(event => {
    if (!event.startTime) return false
    return event.startTime.split('T')[0] === dateString
  })
}

const weekDays = computed(() => {
  const days = []
  const names = ['Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота', 'Воскресенье']

  for (let i = 0; i < 7; i++) {
    const nextDay = new Date(currentMonday.value)
    nextDay.setDate(currentMonday.value.getDate() + i)

    // Возвращаем как было: YYYY-MM-DD в формате UTC
    const dateString = nextDay.toISOString().split('T')[0]

    const displayDate = nextDay.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit' })

    days.push({
      dayName: names[i],
      displayDate,
      dateString
    })
  }
  return days
})


// Форматирование времени (из ISO строки "2026-08-24T14:30:00" в "14:30")
const formatTime = (dateTimeStr) => {
  if (!dateTimeStr) return ''
  const parts = dateTimeStr.split('T')
  if (parts.length < 2) return ''
  return parts[1].substring(0, 5)
}

// Цвета для разных типов событий
const getEventColor = (type) => {
  switch (type) {
    case 'LESSON': return 'primary'     // Синий
    case 'WEBINAR': return 'secondary'    // Красный
    case 'TASK': return 'red'       // Оранжевый
    case 'SELF_STUDY': return 'green' // Зеленый
    default: return 'primary'
  }
}

const getEventTypeText = (type) => {
  switch (type) {
    case 'LESSON': return 'Занятие'
    case 'WEBINAR': return 'Вебинар Zoom'
    case 'TASK': return 'Дедлайн'
    case 'SELF_STUDY': return 'Сам. работа'
    default: return type
  }
}

// Управление модальным окном
const openCreateDialog = () => {
  newEvent.value = { ...defaultEvent, date: currentMonday.value.toISOString().split('T')[0] }
  createDialog.value = true
  fetchAvailableTeams()
}



// 🗑 Удаление события (DELETE /api/v1/schedule/{id})
const confirmDeleteEvent = async (eventId) => {
  if (!confirm('Удалить это событие из расписания?')) return
  try {
    await customAxios.delete(`/v1/schedule/${eventId}`)
    await fetchWeeklySchedule()
  } catch (e) {
    console.error('Ошибка при удалении:', e)
  }
}

// Функция для безопасного скачивания файла по его ID из БД через защищенный эндпоинт
const downloadSecureFile = async (fileId, originalFileName) => {
  try {
    // Делаем асинхронный запрос с типом ответа 'blob' (бинарные данные)
    const response = await customAxios.get(`/v1/files/download/${fileId}`, {
      responseType: 'blob'
    })

    // Создаем временную ссылку в памяти браузера на полученный бинарный объект
    const blob = new Blob([response.data], { type: response.headers['content-type'] })
    const downloadUrl = window.URL.createObjectURL(blob)

    // Создаем невидимый элемент ссылки, имитируем клик для скачивания и очищаем DOM
    const link = document.createElement('a')
    link.href = downloadUrl
    link.setAttribute('download', originalFileName || 'document')
    document.body.appendChild(link)
    link.click()

    // Освобождаем ресурсы памяти
    link.remove()
    window.URL.revokeObjectURL(downloadUrl)
  } catch (error) {
    console.error('Не удалось скачать файл. Возможно, доступ ограничен или файл удален с сервера:', error)
    alert('Ошибка при скачивании файла. Пожалуйста, обратитесь к администратору.')
  }
}

// Вспомогательные хелперы для иконок документов в списке расписания
const getFileIcon = (fileName) => {
  if (!fileName) return 'mdi-file-document-outline'
  const ext = fileName.split('.').pop()?.toLowerCase()
  switch (ext) {
    case 'pdf': return 'mdi-file-pdf-box'
    case 'doc':
    case 'docx': return 'mdi-file-word-box'
    case 'xls':
    case 'xlsx': return 'mdi-file-excel-box'
    case 'ppt':
    case 'pptx': return 'mdi-file-powerpoint-box'
    default: return 'mdi-file-document-outline'
  }
}

const getFileIconColor = (fileName) => {
  if (!fileName) return 'grey'
  const ext = fileName.split('.').pop()?.toLowerCase()
  switch (ext) {
    case 'pdf': return 'red-darken-1'
    case 'doc':
    case 'docx': return 'blue-darken-2'
    case 'xls':
    case 'xlsx': return 'green-darken-2'
    case 'ppt':
    case 'pptx': return 'orange-darken-2'
    default: return 'grey-darken-2'
  }
}

// Функция проверяет, есть ли среди прикрепленных материалов видеофайлы (например, по наличию поля sourceHlsIndex)
const hasVideoMaterials = (materials) => {
  if (!materials || materials.length === 0) return false
  return materials.some(mat => mat.sourceHlsIndex || mat.posterName)
}

// Открытие модального окна просмотра видео для конкретного занятия
const openMediaForEvent = (event) => {
  // Фильтруем и вытаскиваем только видеофайлы из общего списка материалов занятия
  const eventVideos = event.attachedMaterials.filter(mat => mat.sourceHlsIndex || mat.posterName)

  // Вызываем функцию открытия, передавая объект и массив его видеороликов
  openVideoDialog({
    id: event.id,
    courseModuleName: event.title,
    videoFiles: eventVideos
  })
}

function openVideoDialog(mod) {
  activeModule.value = mod
  videoFiles.value = mod.videoFiles
  mediaDialog.value = true
}

function closeMediaModal() {
  mediaDialog.value = false
  activeModule.value = null
}

// Функция принимает грязный путь и вырезает базовую директорию сервера
function formatServerPath(path) {
  if (!path) return '';
  // Регулярное выражение находит //var/www/esse2 или /var/www/esse2
  return path.replace(/^\/{1,2}var\/www\/esse2/, '');
}


function initHlsPlayer(videoElement, streamUrl) {
  if (!videoElement || !streamUrl) return;

    // Формируем путь к дочернему мультибитрейтному индексу
    let correctedStreamUrl = streamUrl;
    if (!correctedStreamUrl.includes('/ts/')) {
      correctedStreamUrl = correctedStreamUrl.replace("index.m3u8", "ts/index.m3u8");
    }


  console.log("🎬 Запуск HLS потока:", correctedStreamUrl);

  // 1. Проверяем, поддерживает ли браузер Hls.js (Chrome, Firefox, Edge, Safari на Mac)
  if (window.Hls && window.Hls.isSupported()) {
    startHlsLibrary(videoElement, correctedStreamUrl);
  }
  // 2. ФОЛБЕК НА НАТИВНЫЙ РЕЖИМ (Строго для iPhone/iPad, где Hls.js заблокирован Apple)
  else if (videoElement.canPlayType('application/vnd.apple.mpegurl')) {
    videoElement.src = correctedStreamUrl;
    videoElement.load();

    videoElement.addEventListener('loadedmetadata', () => {
      console.log("🍏 Нативный HLS запущен на iOS (Авто-выбор качества)");
      availableLevels.value = [
        { index: -1, name: 'Авто (Адаптивное)' } // На iOS переключатель заменяем на авто-чип
      ];
    });
  } else {
    // Если библиотеки еще нет в DOM (первый запуск) — инжектим её
    const script = document.createElement('script');
    script.src = '/hls.js';
    script.onload = () => initHlsPlayer(videoElement, streamUrl);
    document.head.appendChild(script);
  }
}



function startHlsLibrary(videoElement, streamUrl) {
  if (!window.Hls.isSupported()) return;

  // Очищаем старый инстанс плеера перед инициализацией нового
  if (currentHlsInstance) {
    currentHlsInstance.destroy();
  }

  const hls = new window.Hls({
    maxMaxBufferLength: 10,
    enableWorker: true
  });

  currentHlsInstance = hls;

  hls.loadSource(streamUrl);
  hls.attachMedia(videoElement);

  // Как только Hls.js прочитает наш файл /ts/index.m3u8 со всеми 4 потоками
  hls.on(window.Hls.Events.MANIFEST_PARSED, function (event, data) {
    console.log("✨ HLS Манифест распарсен. Найдено потоков качества:", data.levels.length);

    // Вытаскиваем и маппим все 4 разрешения из манифеста
    availableLevels.value = data.levels.map((level, index) => ({
      index: index,
      // Если в манифесте прописана высота (например, 720), пишем "720p", иначе "Поток "
      name: level.height ? `${level.height}p` : `Разрешение ${index + 1}`
    })).reverse(); // Разворачиваем массив, чтобы высокое качество (1080p) шло сверху

    currentLevelIndex.value = hls.currentLevel;
  });

  hls.on(window.Hls.Events.ERROR, function (event, data) {
    if (data.fatal) console.error("Критический сбой HLS:", data);
  });
}


  //files
  const handleFilesUpdated = (ids) => {
    attachedFileIds.value = ids;
    fetchWeeklySchedule();
  }

  function addFiles(event){
    selectedEvent.value = event;
    fileDialog.value = true;
  }

   function addVideoFiles(event){
      selectedEvent.value = event;
      mediaDialog.value = true;
    }

    function closeFilesDialog(){
      fileDialog.value = false;
      selectedEvent.value = null;
      attachedFileIds.value = [];
    }

    // Метод скачивания
    const downloadFile = async (id, fileName) => {
      loadingId.value = id
      try {
        const response = await customAxios.get(
          `/v1/files/download/${id}`,{ responseType: 'blob' })

        // Создаем локальную ссылку на blob в памяти браузера
        const blob = new Blob([response.data])
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.setAttribute('download', fileName) // Имя файла при сохранении

        // Симулируем клик для скачивания и удаляем элемент
        document.body.appendChild(link)
        link.click()
        link.remove()

        // Освобождаем память
        window.URL.revokeObjectURL(link.href)
      } catch (error) {
        console.error('Ошибка при скачивании файла:', error)
        alert('Не удалось скачать файл')
      } finally {
        loadingId.value = null
      }
    }


async function deleteMediaFile(id) {
  if (!selectedEvent.value || !id) return;

  if (!confirm(`Вы уверены, что хотите безвозвратно удалить этот видеоролик?`)) return;
  try {
    const r = await customAxios.delete(`/video/upload/${id}/from_event/${selectedEvent.value.id}`);

    if (r.status === 202) {
      // 1. Обновляем общие данные формы, чтобы бэк отдал чистые новые сеты
      fetchWeeklySchedule();
      showToastPopup ? showToastPopup("Видео успешно удалено!") : alert("Видео успешно удалено!");
    }
  } catch (e) {
    showError(e);
  }
}

async function uploadVideoFile(event) {
console.log("event.target.files" + event.target.files)
  const file = event.target.files?.[0];
  if (!file || !selectedEvent.value) return;

  try {
    downloadAnimation.value = true;
    uploadPercentage.value = 0;

    let formData = new FormData();
    formData.append("file", file); // Передаем чистый файл

    const res = await customAxios.post("/video/upload/to_event/" + selectedEvent.value.id, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: function(progressEvent) {
        if (progressEvent.total) {
          uploadPercentage.value = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
        }
      }
    });

    if (res.status === 201 ) {
      await fetchWeeklySchedule();
      showToastPopup ? showToastPopup("Видео успешно загружено!") : alert("Видео успешно загружено!");
      }
  } catch (e) {
    showError(e);
  } finally {
    downloadAnimation.value = false;
    if (videoInputRef.value) videoInputRef.value.value = "";
  }
}







// Автоматический перезапрос данных при переключении недель кнопками селектора
watch(weekOffset, () => {
  fetchWeeklySchedule()
})

onMounted(() => {
  fetchWeeklySchedule()
})
</script>

<style scoped>
/* Толстая верхняя граница для карточек дней */
.border-top-thick {
  border-top: 4px solid !important;
}

/* Абсолютное позиционирование для кнопки удаления в карточке занятия */
.position-absolute-top-right {
  position: absolute;
  top: 4px;
  right: 4px;
  z-index: 2;
}

.whitespace-pre-line {
  white-space: pre-line;
}

.hover-underline:hover span {
  color: var(--v-theme-primary) !important;
  text-decoration: underline;
}

.text-truncate-1 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90%;
}
</style>

